export const SHIPMENT_RULES = {
  maxWeightLb: 50,
  maxDimensionsIn: [24, 20, 20],
  freeInsuredLabelThreshold: 500,
};

export const SHIPMENT_BOX_LIMIT_HELPER = "Up to 24 × 20 × 20 in and 50 lb per box.";

export const SHIPMENT_RULE_CHECKLIST = [
  "I confirm each box is 50 lb or less and fits within 24 x 20 x 20 in.",
  "I confirm this shipment is reasonably consolidated.",
  "I confirm items are protected with suitable packaging.",
  "I understand shipments that do not follow these rules may be cancelled.",
];

export const parseShipmentNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const boxFitsDimensionLimit = (boxDimension = {}) => {
  const sides = [boxDimension.length, boxDimension.width, boxDimension.height]
    .map(parseShipmentNumber)
    .filter((side) => side > 0)
    .sort((a, b) => a - b);

  if (sides.length !== 3) return true;

  return sides[0] <= 20 && sides[1] <= 20 && sides[2] <= 24;
};

export const getBoxRuleErrors = (boxDimension = {}) => {
  const errors = {};
  const weight = parseShipmentNumber(boxDimension.weight);

  if (weight > SHIPMENT_RULES.maxWeightLb) {
    errors.weight = "Max 50 lb per box.";
  }

  if (!boxFitsDimensionLimit(boxDimension)) {
    errors.dimensions = "Longest side up to 24 in; the other two sides must be 20 in or less.";
  }

  return errors;
};

export const hasBoxRuleErrors = (boxDimension = {}) => Object.keys(getBoxRuleErrors(boxDimension)).length > 0;

export const getShipmentEstimatedValue = (boxes = []) =>
  boxes.reduce(
    (shipmentTotal, box) =>
      shipmentTotal +
      (box.box_items || []).reduce((boxTotal, item) => {
        const price = parseShipmentNumber(item.cashout_price || item.buy_price);
        const quantity = parseShipmentNumber(item.quantity);
        return boxTotal + price * quantity;
      }, 0),
    0
  );

export const formatShipmentCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: value % 1 === 0 ? 0 : 2,
  }).format(parseShipmentNumber(value));
